import { Slider, styled, Tooltip } from "@mui/material"
import React from "react"
import { useResponsive } from "src/utils/useResponsive"

export const CustomSlider = styled(Slider)(({ theme }) => ({
  color: theme.palette.action.disabled,
  height: 8,
  "& .MuiSlider-track": {
    border: "none",
    height: 5,
    backgroundColor: theme.palette.primary.main
  },
  "& .MuiSlider-rail": {
    height: 7
  },
  "& .MuiSlider-thumb": {
    height: 20,
    width: 20,
    backgroundColor: theme.palette.primary.main,
    "&::before": {
      display: "none"
    }
  },
  "& .MuiSlider-mark": {
    height: 5,
    width: 5,
    borderRadius: 25
  }
}))

interface ValueLabelComponentProps {
  children: React.ReactElement
  value: number
}

export const ValueLabelComponent: React.FC<ValueLabelComponentProps> = ({ children, value }) => {
  const { isMobile } = useResponsive()
  return (
    <Tooltip
      title={value}
      placement={isMobile ? "top" : "bottom"}
      enterTouchDelay={0}
      arrow
      componentsProps={{
        tooltip: {
          sx: {
            height: 14,
            fontSize: "0.75rem",
            borderRadius: 20,
            color: "#01294E",
            backgroundColor: "#e6fbff",
            boxShadow: "2px 2px 10px #0000001A",
            py: 0.5,
            px: 1.5
          }
        },
        arrow: {
          sx: {
            color: "#e6fbff"
          }
        }
      }}
    >
      {children}
    </Tooltip>
  )
}
